const regexps = {
    selectLeadingAndEndingCommas: /^,|,$/g
};

export { regexps };
